// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import { LinkPresentationProps } from "@insite/mobius/Link/Link";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TypographyProps } from "@insite/mobius/Typography";
import { color, xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export const securityCodeHelpLink: LinkPresentationProps = {
    icon: {
        iconProps: {
            src: HelpCircle,
            size: 18,
            css: css`
                svg {
                    background: ${color("primary")};
                    color: ${color("common.white")};
                    border-radius: 50%;

                    & > circle {
                        color: ${color("primary")};
                    }
                }
            `,
        },
    },
    css: css`
        margin-left: 16px;
    `,
};

export const securityCodeTextInput: TextFieldPresentationProps = {
    cssOverrides: {
        formInputWrapper: css`
            display: flex;
            align-items: center;
        `,
        inputSelect: css`
            max-width: 90;
        `,
    },
};

interface CheckoutReviewAndSubmitStyle {
    reviewSection: {
        label: TypographyProps;
        value: TypographyProps;
        gridItem?: GridItemProps;
        dividerGridItem?: GridItemProps;
    };
}

export const checkoutReviewAndSubmitStyle: CheckoutReviewAndSubmitStyle = {
    reviewSection: {
        label: {
            size: 12,
            weight: "bold",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-right: 8px;
                white-space: nowrap;
                &:after {
                    content: ":";
                }
            `,
        },
        value: {
            size: 12,
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
        gridItem: {
            width: [12, 6, 5.1, 3.6, 3.6] as any,
            css: css`
                &&& {
                    ${xScreen("lte", "sm")} {
                        margin-bottom: 8px;
                    }
                }
            `,
        },
        dividerGridItem: {
            width: 12,
            css: css`
                height: 1px;
                background: ${color("common.ui5")};
                padding: 0;
                &&& {
                    margin-top: 32px;
                    margin-bottom: 15px;

                    @media print {
                        margin-top: 8px;
                        margin-bottom: 0;
                    }
                }
            `,
        },
    },
};
